import React from "react";
import colors, { TypeColorNames } from '../../../theme/colors';
import styled from "styled-components";

const IconContainer = styled.span`
    display: flex;
    align-items: center;
`;
export interface ILeftArrowIcon {
    
    style?: React.CSSProperties;
    colorSecondary: TypeColorNames;
  }

const LeftArrowIcon: React.FC<ILeftArrowIcon> = ({colorSecondary, style}) => {

    return(
        <IconContainer style={{...style}}>
             <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill={colorSecondary} />
                <path
                  d="M21.0537 29.0537H32.8232L27.6813 34.1956C27.2703 34.6065 27.2703 35.2809 27.6813 35.6918C28.0922 36.1027 28.756 36.1027 29.167 35.6918L36.1107 28.7481C36.5216 28.3372 36.5216 27.6734 36.1107 27.2624L29.1775 20.3082C28.9806 20.1109 28.7134 20 28.4346 20C28.1559 20 27.8887 20.1109 27.6918 20.3082C27.2809 20.7191 27.2809 21.3829 27.6918 21.7939L32.8232 26.9463H21.0537C20.4742 26.9463 20 27.4205 20 28C20 28.5795 20.4742 29.0537 21.0537 29.0537Z"
                  fill={colors.black}
                />
              </svg>
        </IconContainer>
    )
}

export default LeftArrowIcon;

